import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { FancyIcon, WfButton, WfIconContentWarningFill } from "@WahooFitness/redesignr";

type RecoverySourceConfirmDrawerProps = {
  title: ReactNode;
  body: ReactNode;
  confirmLabel: ReactNode;
  cancelLabel: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
};

// The warning sheet both recovery-source confirmations share. Same shape as
// MentalRecoveryAcceptanceDrawer so the warning sheets read as one pattern.
const RecoverySourceConfirmDrawer = ({
  title,
  body,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: RecoverySourceConfirmDrawerProps) => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      width="100%"
      py={2}
      px={2}
      gap={2}
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      bgcolor={palette.background.level1}
    >
      <FancyIcon icon={<WfIconContentWarningFill />} color="warning" size="medium" />
      <Typography variant="prose-md-medium" color={palette.text.primary}>
        {title}
      </Typography>
      <Typography variant="prose-sm" color={palette.text.secondary}>
        {body}
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center" width="100%" mt={1} gap={1}>
        <WfButton hierarchy="primary" intent="default" size="large" fullWidth onClick={onConfirm}>
          {confirmLabel}
        </WfButton>
        <WfButton hierarchy="tertiary" intent="default" size="large" fullWidth onClick={onCancel}>
          {cancelLabel}
        </WfButton>
      </Box>
    </Box>
  );
};

export default RecoverySourceConfirmDrawer;
